import product1 from "./2000-chair/title.jpg"
import product1Img1 from "./2000-chair/img1.jpg"
import product1Img2 from "./2000-chair/img2.jpg"
import product1Img3 from "./2000-chair/img3.png"


import product2 from "./2500-chair/title.webp"
import product2Img1 from "./2500-chair/img1.webp"
import product2Img2 from "./2500-chair/img2.png"
import product2Img3 from "./2500-chair/img3.png"


import product3 from "./2000-IS/title.webp"
import product3Img1 from "./2000-IS/img1.webp"

import product4 from "./combo/title.webp"
import product4Img1 from "./combo/img1.webp"


import product5 from "./SL-Z3/title.jpg"
import product5Img2 from "./SL-Z3/img2.jpg"
import product5Img1 from "./SL-Z3/img1.jpg"


import product6 from "./H5/title.jpg"
import product6Img1 from "./H5/img1.jpg"
import product6Img2 from "./H5/img2.jpg"
import product6Img3 from "./H5/img3.jpg"


export const s4optikProducts = [
  {
  id: 9,
  name: '2000 CH Examination Chair',
  title: '2000 CH Examination Chair',
  image: product1,  // Placeholder for the main image variable
  images: {
    img1: product1Img1,  // Placeholder for additional image variables
    img2: product1Img2,
    img3: product1Img3,
  },
  features: {
    feature1: "Ergonomic design for enhanced patient comfort during exams.",
    feature2: "Adjustable height, backrest, and leg rest for versatile positioning.",
    feature3: "Sturdy construction with high-quality materials for durability.",
    feature4: "User-friendly controls for smooth adjustments and integration."
  },
  description: "Improve patient comfort and streamline examinations with this ergonomic chair. Its adjustable features and robust build ensure reliable performance in various clinical settings.",
  link: "https://s4optik.com/product/s4optik-2000-ch-examination-chair"  // Placeholder for the product link
  },
  {
  id: 10,
  name: '2500 CH Examination Chair',
  title: "2500 CH Examination Chair",
  image: product2,
  images: {
    img1: product2Img1,
    img2: product2Img2,
    img3: product2Img3,
  },
  features: {
    feature1: "Advanced ergonomic design for superior patient comfort during exams.",
    feature2: "Fully adjustable height, backrest, and leg rest for flexible positioning.",
    feature3: "High-quality materials and construction ensure long-lasting durability.",
    feature4: "Intuitive controls for easy adjustments and seamless integration into clinical practice."
  },
  description: "Enhance patient comfort and streamline your exam process with this ergonomic and durable chair. It provides reliable performance for various clinical applications.",
  link: "https://s4optik.com/product/s4optik-2500-ch-examination-chair"
  },
   {
    id: 11,
    name: '2000-ST Instrument Stand',
    title: "2000-ST Instrument Stand",
    image: product3,
    images: {
      img1: product3Img1,
    },
    features: {
      feature1: "Durable construction with a stable base for reliable support during exams.",
      feature2: "Adjustable height and positioning for flexible use with various instruments.",
      feature3: "Integrated components for easy access to essential tools and equipment.",
      feature4: "Ergonomic design enhances functionality and convenience in clinical settings."
    },
    description: "Optimize your clinical workflow with this versatile and durable instrument stand, offering flexible height adjustments and a stable base for reliable performance.",
    link: "https://s4optik.com/product/s4optik-2000-st-instrument-stand"
  },
   {
    id: 10,
    name: '2000 Combo Chair and Stand',
    title: '2000 Combo Chair and Stand',
    image: product4,  // Placeholder for the main image variable
    images: {
      img1: product4Img1,  
      img2: product3Img1,
      img3: product1Img1,
    },
    features: {
      feature1: "Integrated chair and stand system for efficient setups.",
      feature2: "Adjustable features for optimal patient positioning.",
      feature3: "Durable build with high-quality materials for reliability.",
      feature4: "User-friendly controls for smooth operation and adjustments."
    },
    description: "Streamline your examination process with integrated design and adjustable features, enhancing patient comfort and clinical efficiency.",
    link: "https://s4optik.com/product/s4optik-2000-combo-chair-and-stand"  // Placeholder for the product link
  },
   {
  id: 11,
  name: 'SL-Z3 Slit Lamp',
  title: "SL-Z3 Slit Lamp",
  image: product5,  // Placeholder for the main image variable
  images: {
    img1: product5Img1,  // Placeholder for additional image variables
    img2: product5Img2,
    
  },
  features: {
    feature1: "High-quality optics for detailed anterior segment examination.",
    feature2: "Wide range of illumination options and magnification settings.",
    feature3: "Ergonomic design for ease of use and patient comfort.",
    feature4: "Durable construction with precision engineering for reliable performance."
  },
  description: "Examine the anterior segment with clarity and precision with versatile illumination and magnification options.",
  link: "https://s4optik.com/product/s4optik-sl-z3-slit-lamp"  // Placeholder for the product link
  },
   {
  id: 12,
  name: 'SL-H5 Slit Lamp',
  title: "SL-H5 Slit Lamp",
  image: product6,  // Placeholder for the main image variable
  images: {
    img1: product6Img1,  // Placeholder for additional image variables
    img2: product6Img2,
    img3: product6Img3,
  },
  features: {
    feature1: "Advanced optics for detailed and precise anterior segment imaging.",
    feature2: "Multiple illumination options and magnification levels for versatile examination.",
    feature3: "Ergonomic design enhances user comfort and patient experience.",
    feature4: "Robust build with high-quality materials ensures long-term durability and reliability."
  },
  description: "Achieve detailed anterior segment imaging with versatile illumination and magnification settings. Enhance clarity and patient comfort during examinations.",
  link: "https://s4optik.com/product/s4optik-sl-h5-slit-lamp"  // Placeholder for the product link
}
   
  
];